<script setup>
const props = defineProps({
    type: {
        type: String,
        required: true
    },
    vars: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['close']);

function handleClose() {
    emit('close');
}
</script>

<template>
    <div :class="type + '-inner'">
        <div v-if="vars.title" :class="type + '-title'">
            <h1>{{ vars.title }}</h1>
            <p v-if="type === 'fullpanel'" class="fullpanel-title-close">
                <a href="#" @click.prevent="handleClose"></a>
            </p>
        </div>
        <div :class="type + '-main'">
            <div :class="type + '-main-inner'">
                <p>{{ vars.lead }}</p>
            </div>
            <div :class="type + '-btns'">
                <a class="btn btn-modal_close" href="#" @click.prevent="handleClose">CLOSE</a>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* デフォルトモーダルのスタイル（必要に応じて追加） */
</style>

